import React from "react";
import Select from "../../../components/Select";

export default function SelectionComponent({ description, selectionCallback, selectedItems, options, isMobile }) {
    return (
        <div
            style={{
                boxShadow: "0 5px 10px rgba(0, 0, 0, 0.2)",
                border: "1px solid #CCC",
                borderRadius: 3,
                marginLeft: 10,
                marginTop: 5,
                padding: 10,
                width: isMobile ? "90%" : "30%"
            }}
        >
            <div style={{ display: "flex" }}>
                <h5
                    style={{
                        margin: "auto",
                        display: "block",
                        fontSize: "18px"
                    }}
                >
                    {description}
                </h5>
            </div>
            <div style={{ position: "overlay", marginTop: "20px" }}>
                <Select
                    style={{ position: "overlay" }}
                    multi={true}
                    onSelect={selectionCallback.bind(this)}
                    selected={selectedItems}
                    options={options}
                    isSearchable={!isMobile}
                />
            </div>
        </div>
    );
}
